/** Wrapper box, in percent of the composition, that crops the source video. */
export interface CropWrapperBox {
  widthPct: number;
  heightPct: number;
  leftPct: number;
  topPct: number;
}

const IDENTITY: CropWrapperBox = { widthPct: 100, heightPct: 100, leftPct: 0, topPct: 0 };

/**
 * The reframe crop of the default composition: the source is drawn into an
 * oversized wrapper (cover width × zoom, full height × zoom) placed so the
 * crop point (x%, y% of the source) sits at the center of the frame, clamped
 * so the source always covers it.
 *
 * The ONE geometry for the editor preview (`ProjectClipComposition`) and the
 * export (`RenderComposition`), so a zoomed keyframe frames the same window
 * in both; the cover capture crops that window too
 * (`computeCoverCropRect`, tested against this).
 */
export function computeCropWrapperBox({
  cropPosition,
  sourceAspect,
  compAspect,
}: {
  cropPosition: { x: number; y: number; zoom: number } | null | undefined;
  sourceAspect: number;
  compAspect: number;
}): CropWrapperBox {
  if (!cropPosition) return IDENTITY;
  const scaleRatio = (sourceAspect / compAspect) * cropPosition.zoom;
  const heightScale = cropPosition.zoom;
  return {
    widthPct: scaleRatio * 100,
    heightPct: heightScale * 100,
    leftPct: Math.max(-(scaleRatio - 1) * 100, Math.min(0, 50 - scaleRatio * cropPosition.x)),
    topPct: Math.max(-(heightScale - 1) * 100, Math.min(0, 50 - heightScale * cropPosition.y)),
  };
}
